import { passkeyClient } from "@better-auth/passkey/client";
import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";
import { apiOrigin } from "./api";

export const authClient = createAuthClient({
  baseURL: apiOrigin || window.location.origin,
  basePath: "/api/auth",
  plugins: [magicLinkClient(), passkeyClient()],
});

